import { createApp } from "vue";
import { setupCalendar } from 'v-calendar';
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";
import ClubSearch from "./ClubSearch.vue";
import { getPinia } from "@/shared/pinia";

const app = createApp(ClubSearch);
app.use(getPinia());
app.use(setupCalendar, {});
app.use(Notifications, { velocity });

if (document.getElementById('club-search')) {
    app.mount("#club-search");
}